import React from 'react';
import PropTypes from 'prop-types';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';

const useStyles = buildUseStyles('PieChartLegendItem', (theme) => ({
  container: {
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
  },
  outerCircle: {
    minWidth: '21px',
    minHeight: '21px',
    width: '21px',
    height: '21px',
    border: '1px solid',
    borderRadius: '50%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'relative',
    backgroundColor: 'transparent',
  },
  innerCircle: {
    width: '15px',
    height: '15px',
    borderRadius: '50%',
  },
  value: {
    paddingLeft: theme.spacing(1),
  },
}));

const PieChartLegendItem = ({
  item,
  onLegendClick,
  index,
  selected,
}) => {
  const classes = useStyles();

  const outerCircleColor = selected ? item.color : 'transparent';

  return (
    <div
      key={item.value}
      onClick={() => onLegendClick(item, index)}
      className={classes.container}
      role="button"
      tabIndex={index}
      aria-hidden="true"
    >
      <div className={classes.outerCircle} style={{ borderColor: outerCircleColor }}>
        <div className={classes.innerCircle} style={{ backgroundColor: item.color }} />
      </div>
      <span className={classes.value}>{item.value}</span>
    </div>
  );
};

PieChartLegendItem.defaultProps = {
  onLegendClick: () => {},
  selected: false,
};

PieChartLegendItem.propTypes = {
  item: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
  onLegendClick: PropTypes.func,
  selected: PropTypes.bool,
};

export default PieChartLegendItem;
